import * as Config from '../../../config';
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, useRouteMatch } from "react-router-dom";
import { connect } from "react-redux";

import Content from '../common/Content';
// import GridReleases from '../content/grid/GridReleases';
import GridCharts from '../content/grid/GridCharts';
import ListColumns from '../content/list/ListColumns';
import ListV2 from '../content/list/ListV2';
import SubMenu from '../common/SubMenu';
import TrendsV2 from '../trends/TrendsV2';
import GenresManager from '../custom/-APP_TARGET/content/GenresManager';
import GenresRoute from '../custom/-APP_TARGET/content/GenresRoute';
// import RadioButton from '../automix/RadioButton';
import AutomixStandAloneButton from '../automix/AutomixStandAloneButton';

function ConnectedGenreV2({ id, name, search, category = null, notsearch = null, hasSideMenu = true, dimension }) {
  let { url } = useRouteMatch();
  const { width, height } = dimension;
  const cutName = (name.length > 25 && width < 1200) ? Config.limitString(name, 21) : name;
  const nameFiltered = name.replace(`(`, `/`).replace(`)`, ``).split(`/`).map(x => x.trim()).join(`,`);

  const aTrends = useMemo(() => {
    let base = [{
      id: `artists-${id}`, type: 'artists', title: `Trending Artists`, props: [`artists`, `remixers`], format: `formattedArtist`, isRandom: true, isRanked: false,
      grid: {
        rowWidth: 142, //135
        rowHeight: 165, //145,
        rowPadding: 4,
        coverBorder: 4,
        gap: 8,
        hasPagination: true,
        blockClassName: 'card-artist',
        coverClassName: 'cover-artist'
      }
    }];
    if (Config.GENRES_HAS_TRENDING_LABELS) {
      base.push({
        id: `labels-${id}`, type: 'labels', title: `Trending Labels`, props: [`release|label`], format: `formattedLabel`, isRandom: true, isRanked: false,
        grid: {
          rowWidth: 142, //135
          rowHeight: 168, //158 //138,
          rowPadding: 8,
          coverBorder: 0,
          gap: 8,
          hasPagination: true,
          blockClassName: 'card-label',
          coverClassName: 'cover-label'
        }
      })
    }
    return base;
  }, [id])

  const hasRadio = (window.location.pathname.includes(`featured`));
  const hasHype = (Config.GENRES_HAS_HYPE && ([89,39,12,1,3,5,37,96,90,14,93,15,6,11,7].includes(id)));
  const hasExclusive = Config.GENRES_HAS_EXCLUSIVE;
  const hasCharts = (category && category.id && category.id === 1);
  const reduceTitle = (window.location.pathname.includes(`top100`));
  const maxReduce = hasSideMenu ? ([1,3,11,12,37,39,89,90,14,93,96,15,6,7].includes(id) && hasCharts) : false;
  const isDjExclusives = (category && category.id && category.id === 2 && id === 11);
  const isDjEdits = (id === 110);

  return (
    <Content name={cutName} isSticky={true} 
      styleHeader={{width: hasSideMenu ? width - Config.SUB_SIDEBAR + (Config.CONTENT_PAD * 1.9) : width + (Config.CONTENT_PAD * 2)}}
      contentClassName={'hasStickyHeader'}
      titleClassName={reduceTitle ? `ellipsis-title${maxReduce ? '-max' : ''}` : ''}
      subContent={
        <div className={'flexRow'}>
          <div className={`flexRow slider-menu genres-menu`}>
            { !isDjEdits && <SubMenu to={`${url}/featured`} or={`${url}`} label={`Trending`} /> }
            {/* { !isDjEdits && <SubMenu to={`${url}/top100`} label={`Top 100`} /> } */}
            { hasCharts && <SubMenu to={`${url}/charts`} label={`Charts`} /> }
            { !isDjEdits && <SubMenu to={`${url}/tracks`} label={`Tracks`} /> }
            { (!isDjExclusives && !isDjEdits) && <SubMenu to={`${url}/releases`} label={`Releases`} /> }
            { (hasExclusive && hasCharts) && <SubMenu to={`${url}/exclusives`} label={`Exclusives`} style={{paddingLeft: 9}} />}
            { hasHype && <SubMenu to={`${url}/hype`} label={`Hype`} />}
          </div>
          {/* {hasRadio && <RadioButton className={'discover-radio-button'} />} */}
          { hasRadio && <AutomixStandAloneButton pathApi={`/v4/catalog/genres/${id}/top/100/?per_page=100`} uid={`${name} - Top 100`} from={`${url}/top100`} className={`genre-automix-button`} isShow={true} /> }
        </div>
      }
    >
      <Switch>
        <Route exact path={[`${url}`, `${url}/featured`]}>
          <>
            <ListColumns
              title={'Top 100'}
              pathApi={`/v4/catalog/genres/${id}/top/20`}
              linkToUID={`${name} - Top 100`}
              id={`{A}listC-top10`}
              width={ hasSideMenu ? width - Config.SUB_SIDEBAR + (Config.LC_LEFT_PAD * 2) : width}
              height={(Config.LIST_ROW_HEIGHT * 5)}
              size={Config.LIST_ROW_HEIGHT}
              columnCount={2}
              rowCount={5}
              rowType={`Column`}
              hasPagination={true} allTo={`${url}/top100`} allLabel={`View All`}
              style={{ marginTop: -40 }}
              enableArrows={false}
            />
            <GenresManager url={url} id={id} name={nameFiltered} search={search} notsearch={notsearch} />
            <TrendsV2
              pathApi={`/v4/catalog/genres/${id}/top/100/?enabled=true&per_page=100`}
              width={ hasSideMenu ? width - Config.SUB_SIDEBAR : width}
              style={{marginBottom: 32}}
              params={aTrends}
            />
          </>
        </Route>
        <Route path={`${url}/top100`}>
          <ListV2
            subTitle={`Top 100`}
            titleContainerClassName={'list-columns-headers'}
            titleClassName={'bp-h6 type-regular'}
            pathApi={`/v4/catalog/genres/${id}/top/100?per_page=100`}
            sortable={false}
            id={`G-${id}-top100`}
            width={ hasSideMenu ? width - Config.SUB_SIDEBAR : width}
            height={height - Config.STICKY_HEADER_HEIGHT}
            size={Config.LIST_ROW_HEIGHT}
            style={{ marginTop: -10 }}
            isLoadMore={false}
            filtersStyle={{position: `absolute`, top: 23, right: 279}}
            panelStyle={{ margin: `0px 0px 16px 0px` }}
            type={`Full#`}
            orderBy={[`release`, `top`, `title`, `mix_name`, `remixers_s`, `label`, `genre_s`, `key_camelot`, `bpm`, `artists_s`]}
            filters={[`track_name`,  /*`mix_name`,*/ `artists_s`, `remixers_s`, `label`, `bpm`, `key`]}
            isBoost={true}
            automix={true}
            automixStyle={{ position: `absolute`, top: 23, left: `auto`, right: 0 }}
            automixName={`${name} - Top 100`}
            from={`${url}/top100`}
            enableShortcuts={true}
            enableSave={true}
            saveName={`${name} - Top 100`}
          />
        </Route>
        {/* <Route path={`${url}/releases`}>
          <GridReleases id={`${name}_releases`} width={width - Config.SUB_SIDEBAR} perPage={100}
            height={ height - (Config.TAB_BAR_GUTTER * 4.3) }
            style={{ marginTop: -15 }} 
            hasFilters={true} 
            filtersStyle={{ top: 80, height: 250, marginTop: -7 }}
            buttonFilterStyle={{ top: 23 }}
            pathApi={`/v4/catalog/releases/?genre_id=${id}&enabled=true&preorder=false&order_by=-publish_date&per_page=100`}
            className={`grid-chart genre-all`}
            showLoading={true}
          />
        </Route> */}
        <Route path={`${url}/charts`}>
          <GridCharts id={`${name}_charts`} 
            width={ hasSideMenu ? width - Config.SUB_SIDEBAR : width} 
            perPage={100}
            height={ height - (Config.TAB_BAR_GUTTER * 4.3) }
            style={{ marginTop: -15 }} 
            hasFilters={true} 
            filtersStyle={{ top: 80, height: 250, marginTop: -7 }}
            buttonFilterStyle={{ top: 23 }}
            pathApi={`/v4/catalog/charts/?genre_id=${id}&enabled=true&is_published=true&per_page=100|45,958601` /* 2808395 */}
            className={`grid-chart genre-all`} 
            showLoading={true}
          />
        </Route>
        <Route path={`${url}/tracks`}>
          <ListV2
            pathApi={`/v4/catalog/tracks/?genre_id=${id}&per_page=100&preorder=false&order_by=-publish_date` /* /v4/catalog/genres/${id}/tracks/?per_page=100 */}
            sortable={false}
            id={`G-${id}-tracks`}
            width={ hasSideMenu ? width - Config.SUB_SIDEBAR : width}
            height={height - Config.STICKY_HEADER_HEIGHT}
            size={Config.LIST_ROW_HEIGHT}
            style={{marginTop: -10}}
            isLoadMore={true}
            filtersStyle={{position: `absolute`, top: 23, right: 127}}
            panelStyle={{ margin: `0px 0px 16px 0px` }}
            type={`Full`}
            orderBy={[`title`, `label`, /*`genre_s`,*/ `release`]}
            filters={[`genre_track_name`, /*`mix_name`,*/ `artists_s`, `remixers_s`, `label`, `publish_date`, `bpm`, `key_convert`, 'preorders']}
            automix={true}
            automixName={`${name} - Tracks`}
            automixStyle={{ position: `absolute`, top: 23, left: `auto`, right: 0 }}
            from={`${url}/tracks`}
          />
        </Route>
        <Route path={`${url}/exclusives`}>
          <ListV2
            pathApi={`/v4/catalog/tracks/?genre_id=${id}&was_ever_exclusive=true&per_page=100&preorder=false&order_by=-publish_date` /* /v4/catalog/genres/${id}/tracks/?per_page=100 */}
            sortable={false}
            id={`G-${id}-exclusives`}
            width={ hasSideMenu ? width - Config.SUB_SIDEBAR : width}
            height={height - Config.STICKY_HEADER_HEIGHT}
            size={Config.LIST_ROW_HEIGHT}
            style={{marginTop: -10}}
            isLoadMore={true}
            filtersStyle={{position: `absolute`, top: 23, right: 127}}
            panelStyle={{ margin: `0px 0px 16px 0px` }}
            type={`Full`}
            orderBy={[`title`, `label`, /*`genre_s`,*/ `release`]}
            filters={[`genre_track_name`, /*`mix_name`,*/ `artists_s`, `remixers_s`, `label`, `publish_date`, `bpm`, `key_convert`, 'preorders']}
            automix={true}
            automixName={`${name} - Exclusives`}
            automixStyle={{ position: `absolute`, top: 23, left: `auto`, right: 0 }}
            from={`${url}/exclusives`}
          />
        </Route>
        <Route path={`${url}/hype`}>
          <ListV2
            pathApi={`/v4/catalog/tracks/?genre_id=${id}&is_hype=true&per_page=100&preorder=false&order_by=-publish_date` /* /v4/catalog/genres/${id}/tracks/?per_page=100 */}
            sortable={false}
            id={`G-${id}-hype`}
            width={ hasSideMenu ? width - Config.SUB_SIDEBAR : width}
            height={height - Config.STICKY_HEADER_HEIGHT}
            size={Config.LIST_ROW_HEIGHT}
            style={{marginTop: -10}}
            isLoadMore={true}
            filtersStyle={{position: `absolute`, top: 23, right: 127}}
            panelStyle={{ margin: `0px 0px 16px 0px` }}
            type={`Full`}
            orderBy={[`title`, `label`, /*`genre_s`,*/ `release`]}
            filters={[`genre_track_name`,  /*`mix_name`,*/ `artists_s`, `remixers_s`, `label`, `publish_date`, `bpm`, `key_convert`,'preorders']}
            automix={true}
            automixName={`${name} - Hype`}
            automixStyle={{ position: `absolute`, top: 23, left: `auto`, right: 0 }}
            from={`${url}/hype`}
          />
        </Route>
      </Switch>
      <GenresRoute url={url} id={id} name={name} hasSideMenu={hasSideMenu} />
    </Content>
  )
}

ConnectedGenreV2.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  search: PropTypes.string,
  notsearch: PropTypes.string,
}

const GenreV2 = connect(
  state => ({
    dimension: state.dimension
   })
)(ConnectedGenreV2);

export default GenreV2;
